
const basicconfig = {

  //////////////////////////
  //    AUTH
  //////////////////////////

  branchtype: {
    service: {
      name: 'branchtype',
      title: 'Branch Type',
    }
  },

  // gender: {
  //   service:{
  //     name:'gender',
  //     title:'Gender',
  //   }
  // },

  version: {
    service: {
      name: 'version',
      title: 'App Version',
    }
  },
  //////////////////////////
  //    CORE
  //////////////////////////

  country: {
    service: {
      name: 'country',
      title: 'Country',
    }
  },

  currency: {
    service: {
      name: 'currency',
      title: 'Currency',
    }
  },

  dashtab: {
    service: {
      name: 'dashtab',
      title: 'Dash Tabs'
    },
    create: false
  },
  dashtype: {
    service: {
      name: 'dashtype',
      title: 'Dash Type',
    }
  },

  // devicetype: {
  //   service:{
  //     name:'devicetype',
  //     title:'Device Type',
  //   }
  // },

  gender: {
    service: {
      name: 'gender',
      title: 'Gender',
    }
  },

  idtype: {
    service: {
      name: 'idtype',
      title: 'ID Type',
    }
  },

  region: {
    service: {
      name: 'region',
      title: 'Region',
    }
  },

  report: {
    service: {
      name: 'report',
      title: 'Reports',
    }
  },

  //////////////////////////
  //    PLATFORM 
  //////////////////////////

  attendancestatus: {
    service: {
      name: 'attendancestatus',
      title: 'Attendance State',
    }
  },

  auditoriumlocation: {
    service: {
      name: 'auditoriumlocation',
      title: 'Auditoriumns',
    }
  },

  checkinmethod: {
    service: {
      name: 'checkinmethod',
      title: 'Checkin Methods',
    }
  },

  committeetype: {
    service: {
      name: 'committeetype',
      title: 'Committee Types',
    }
  },

  activitytype: {
    service: {
      name: 'activitytype',
      title: 'Activity Type',
    }
  },

  contributionstatus: {
    service: {
      name: 'contributionstatus',
      title: 'Contribution State',
    }
  },

  donationstatus: {
    service: {
      name: 'donationstatus',
      title: 'Donation State',
    }
  },

  executiverole: {
    service: {
      name: 'executiverole',
      title: 'Executive Role',
    }
  },

  staffrole: {
    service: {
      name: 'staffrole',
      title: 'Staff Roles',
    }
  },

  grouptype: {
    service: {
      name: 'grouptype',
      title: 'Group Types',
    }
  },

  marriagetype: {
    service: {
      name: 'marriagetype',
      title: 'Marriage Types',
    }
  },

  contributiontype: {
    service: {
      name: 'contributiontype',
      title: 'Contribution Type',
    }
  },

  customertype: {
    service: {
      name: 'customertype',
      title: 'Customer Type',
    }
  },

  devicetype: {
    service: {
      name: 'devicetype',
      title: 'Device Type',
    }
  },

  eventstate: {
    service: {
      name: 'eventstate',
      title: 'Event State',
    }
  },

  eventtype: {
    service: {
      name: 'eventtype',
      title: 'Event Type',
    }
  },

  notificationstate: {
    service: {
      name: 'notificationstate',
      title: 'Notification State',
    }
  },

  notificationtype: {
    service: {
      name: 'notificationtype',
      title: 'Notification Type',
    }
  },

  messagetype: {
    service: {
      name: 'messagetype',
      title: 'Message Type',
    }
  },
  messagemode: {
    service: {
      name: 'messagemode',
      title: 'Message Mode',
    }
  },
  messagechannel: {
    service: {
      name: 'messagechannel',
      title: 'Message Channel',
    }
  },

  //////////////////////////
  //    API
  //////////////////////////


  //////////////////////////
  //    AGENCY
  //////////////////////////

  // agency: {
  //   service:{
  //     name:'agency',
  //     title:'Agency',
  //   }
  // },


  //////////////////////////
  //    UPLOAD
  //////////////////////////

  filegroup: {
    service: {
      name: 'filegroup',
      title: 'File Group',
    }
  },

  paramgroup: {
    service: {
      name: 'paramgroup',
      title: 'Parameter Group',
    }
  },

  paramstatus: {
    service: {
      name: 'paramstatus',
      title: 'Parameter Status',
    }
  },

  //////////////////////////
  //    CONTENT
  //////////////////////////

  uidevice: {
    service: {
      name: 'uidevice',
      title: 'UI Device',
    }
  },

  uidoc: {
    service: {
      name: 'uidoc',
      title: 'UI Document',
    }
  },

  uilang: {
    service: {
      name: 'uilang',
      title: 'UI Language',
    }
  },

  uipage: {
    service: {
      name: 'uipage',
      title: 'UI Page',
    }
  },

  uisection: {
    service: {
      name: 'uisection',
      title: 'UI Section',
    }
  },

  orgtype: {
    service: {
      name: 'orgtype',
      title: 'Organization Type',
    }
  },

  linktype: {
    service: {
      name: 'linktype',
      title: 'Link Type',
    }
  },

  linkstate: {
    service: {
      name: 'linkstate',
      title: 'Link State',
    }
  }

};

export { basicconfig };
